var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5C2.067 0.5 0.5 2.067 0.5 4V5.75H28.5V4C28.5 2.067 26.933 0.5 25 0.5H4Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 9.25H0.5V18C0.5 19.933 2.067 21.5 4 21.5H25C26.933 21.5 28.5 19.933 28.5 18V9.25ZM4 16.25C4 15.2835 4.7835 14.5 5.75 14.5H7.5C8.4665 14.5 9.25 15.2835 9.25 16.25C9.25 17.2165 8.4665 18 7.5 18H5.75C4.7835 18 4 17.2165 4 16.25ZM12.75 14.5C11.7835 14.5 11 15.2835 11 16.25C11 17.2165 11.7835 18 12.75 18H14.5C15.4665 18 16.25 17.2165 16.25 16.25C16.25 15.2835 15.4665 14.5 14.5 14.5H12.75Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/Unknown.b8ed67b63c1986bb824ff32e6e9e4b36.svg";
export { ForwardRef as ReactComponent };